<!-- REGISTRO COMPLETADO — página completa -->
<div *ngIf="isComplete" class="complete-page">
  <div class="complete-inner">

    <!-- Logo -->
    <div class="complete-logo text-center">
      <img src="../../../assets/logo.png" alt="Aliwell">
    </div>

    <!-- Encabezado de bienvenida -->
    <div class="complete-header text-center">
      <h2 class="complete-title">Qué gusto tenerte en Aliwell, {{formData.name}}</h2>
      <p class="complete-body">
        Ya tenemos tu solicitud. Estás a un paso de unirte a los miles de ortodoncistas que tratan a sus
        pacientes con alineadores hechos en México, con respaldo clínico real.
      </p>
      <p class="complete-cta">Vamos a revisarla y te avisamos pronto.</p>
    </div>

    <!-- Lo que vas a encontrar adentro -->
    <div class="complete-section">
      <p class="section-tag">LO QUE VAS A ENCONTRAR ADENTRO</p>
      <div class="benefit-item">
        <span class="benefit-dot"></span>
        <div>
          <p class="benefit-title">Planificación que te ahorra tiempo</p>
          <p class="benefit-body">Subes tu caso, recibes tu plan revisado por nuestro equipo clínico. Sin adivinar.</p>
        </div>
      </div>
      <div class="benefit-item mt-3">
        <span class="benefit-dot"></span>
        <div>
          <p class="benefit-title">Acompañamiento de verdad</p>
          <p class="benefit-body">No te dejamos solo con un portal. Tienes a quién preguntarle cuando un caso se pone complejo.</p>
        </div>
      </div>
      <div class="benefit-item mt-3">
        <span class="benefit-dot"></span>
        <div>
          <p class="benefit-title">Comunidad y formación</p>
          <p class="benefit-body">Casos clínicos, biomecánica y la experiencia de cientos de doctores que ya recorrieron el camino.</p>
        </div>
      </div>
    </div>

    <!-- Instagram -->
    <div class="complete-section text-center">
      <h3 class="ig-heading">¡No te pierdas lo que viene!</h3>
      <p class="ig-body">
        Mientras validamos tu cuenta, en Instagram subimos casos clínicos reales, tips de biomecánica y el detrás
        de cámaras. Es el mejor lugar para ver de qué se trata Aliwell.
      </p>
      <a href="https://www.instagram.com/aliwell.smiles" target="_blank" rel="noopener" class="ig-btn">
        <i class="fa fa-instagram"></i>&nbsp; Síguenos en Instagram
      </a>
      <div class="social-row mt-3">
        <a href="https://www.facebook.com/aliwell.smiles" target="_blank" rel="noopener">Facebook</a>
        <a href="https://www.linkedin.com/company/aliwell" target="_blank" rel="noopener">LinkedIn</a>
        <a href="https://www.youtube.com/@aliwell.smiles" target="_blank" rel="noopener">YouTube</a>
      </div>
    </div>

    <!-- Mientras validamos tu cuenta -->
    <div class="complete-section complete-section--box">
      <p class="section-tag">MIENTRAS VALIDAMOS TU CUENTA</p>
      <div class="next-step">
        <span class="next-num">1</span>
        <p><strong>Revisamos tus datos.</strong> Tu cédula y los datos de tu consultorio. Toma hasta 48 horas hábiles.</p>
      </div>
      <div class="next-step mt-3">
        <span class="next-num">2</span>
        <p><strong>Te llega tu acceso.</strong> Ya te enviamos el correo para crear tu contraseña. Puedes ingresar desde ahora, pero tu cuenta estará activa hasta que validemos tu perfil.</p>
      </div>
      <div class="next-step mt-3">
        <span class="next-num">3</span>
        <p><strong>Arrancamos juntos.</strong> Te guiamos por la plataforma para que empieces tu primer caso sin fricción.</p>
      </div>
    </div>

    <!-- Footer -->
    <div class="complete-footer text-center">
      <p>
        Revisa tu bandeja de entrada y tu carpeta de spam. Si en 48 horas no tienes noticias nuestras,
        escríbenos a <a href="mailto:hola@aliwell.mx" class="footer-email">hola@aliwell.mx</a> y lo resolvemos.
      </p>
      <p class="mt-3 legal-text">
        Consulta nuestro <a href="https://www.aliwell.mx/aviso-de-privacidad" target="_blank" rel="noopener noreferrer">aviso de privacidad</a>
      </p>
    </div>

  </div>
</div>

<!-- WIZARD — dentro del card -->
<div *ngIf="!isComplete" class="registro-bg">
  <div class="registro-card">

    <!-- Logo -->
    <div class="registro-logo text-center">
      <img src="../../../assets/logo.png" alt="Aliwell">
    </div>

    <!-- Barra de progreso -->
    <div class="progress-wrap px-4">
      <div class="progress-track">
        <div class="progress-fill" [style.width.%]="progressPercent"></div>
      </div>
      <p class="step-label">Paso {{currentStep}} de {{totalSteps}}</p>
    </div>

    <!-- Contenido del paso -->
    <div class="step-body px-4">

      <!-- PASO 1: Perfil -->
      <ng-container *ngIf="currentStep === 1">
        <h3 class="step-title">Tu perfil</h3>
        <p class="step-sub">Cuéntanos quién eres para personalizar tu experiencia</p>
        <div class="mt-4">
          <div class="profile-card" [class.profile-card--selected]="isSpecialist" (click)="setProfile(true)">
            <span class="radio-dot" [class.radio-dot--active]="isSpecialist"></span>
            <div>
              <p class="profile-card__label">Soy especialista</p>
              <p class="profile-card__desc">Ortodoncista, odontólogo o especialista dental</p>
            </div>
          </div>
          <div class="profile-card mt-3" [class.profile-card--selected]="!isSpecialist" (click)="setProfile(false)">
            <span class="radio-dot" [class.radio-dot--active]="!isSpecialist"></span>
            <div>
              <p class="profile-card__label">Soy residente</p>
              <p class="profile-card__desc">Estudiante o residente en formación</p>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- PASO 2: Nombre -->
      <ng-container *ngIf="currentStep === 2">
        <h3 class="step-title">Tu nombre</h3>
        <p class="step-sub">Ingresa tu nombre tal como aparece en tu identificación oficial</p>
        <div class="fields-wrap mt-4">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label>Nombre *</mat-label>
            <span matPrefix class="fa fa-user mr-2 prefix-icon">&nbsp;</span>
            <input matInput [(ngModel)]="formData.name" name="name" autocomplete="given-name">
          </mat-form-field>
          <p *ngIf="stepErrors.name" class="error-msg">Ingresa tu nombre</p>

          <div class="name-row">
            <div class="name-field">
              <mat-form-field class="w-100" appearance="fill">
                <mat-label>Apellido paterno *</mat-label>
                <input matInput [(ngModel)]="formData.lastName" name="lastName" autocomplete="family-name">
              </mat-form-field>
              <p *ngIf="stepErrors.lastName" class="error-msg">Requerido</p>
            </div>
            <div class="name-field">
              <mat-form-field class="w-100" appearance="fill">
                <mat-label>Apellido materno *</mat-label>
                <input matInput [(ngModel)]="formData.secondLastName" name="secondLastName">
              </mat-form-field>
              <p *ngIf="stepErrors.secondLastName" class="error-msg">Requerido</p>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- PASO 3: Contacto -->
      <ng-container *ngIf="currentStep === 3">
        <h3 class="step-title">Tu contacto</h3>
        <p class="step-sub">Por estos medios te avisaremos cuando tu cuenta esté lista</p>
        <div class="fields-wrap mt-4">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label>Correo electrónico *</mat-label>
            <span matPrefix class="fa fa-envelope-o mr-2 prefix-icon">&nbsp;</span>
            <input matInput type="email" [(ngModel)]="formData.email" name="email"
                   inputmode="email" autocomplete="email" placeholder="doctor@tuclinica.mx">
          </mat-form-field>
          <p *ngIf="stepErrors.email" class="error-msg">Ingresa un correo válido (ej. doctor@tuclinica.mx)</p>
          <p *ngIf="stepErrors.emailTaken" class="error-msg">Este correo ya tiene una cuenta registrada</p>

          <mat-form-field class="w-100 mt-2" appearance="fill">
            <mat-label>Teléfono *</mat-label>
            <span matPrefix class="fa fa-phone mr-2 prefix-icon">&nbsp;</span>
            <input matInput phoneNumberOnly maxlength="10" minlength="10"
                   [(ngModel)]="formData.phone" name="phone"
                   inputmode="tel" autocomplete="tel" placeholder="10 dígitos">
          </mat-form-field>
          <p *ngIf="stepErrors.phone" class="error-msg">Ingresa un teléfono de 10 dígitos</p>
        </div>
      </ng-container>

      <!-- PASO 4: Consultorio (especialista) / Formación (residente) -->
      <ng-container *ngIf="currentStep === 4">

        <!-- Especialista -->
        <ng-container *ngIf="isSpecialist">
          <h3 class="step-title">Tu consultorio</h3>
          <p class="step-sub">Datos de tu práctica profesional</p>
          <div class="fields-wrap mt-4">

            <div class="checkbox-wrap mb-3">
              <mat-checkbox [(ngModel)]="formData.hasOrthodonticsSpecialty"
                            name="hasOrthodonticsSpecialty"
                            (change)="showOrthodonticsError = false; formData.professionalLicense = ''">
                ¿Cuenta con especialidad en ortodoncia? *
              </mat-checkbox>
              <p *ngIf="showOrthodonticsError" class="error-msg mt-1">Este campo es requerido</p>
            </div>

            <ng-container *ngIf="formData.hasOrthodonticsSpecialty">
              <mat-form-field class="w-100" appearance="fill">
                <mat-label>Cédula profesional *</mat-label>
                <span matPrefix class="fa fa-id-card mr-2 prefix-icon">&nbsp;</span>
                <input matInput onlyNumbers [(ngModel)]="formData.professionalLicense"
                       name="professionalLicense" inputmode="numeric" placeholder="Solo números, sin guiones">
              </mat-form-field>
              <p *ngIf="stepErrors.professionalLicense" class="error-msg">Ingresa tu cédula profesional</p>
            </ng-container>

            <mat-form-field class="w-100 mt-2" appearance="fill">
              <mat-label>Nombre del consultorio *</mat-label>
              <span matPrefix class="fa fa-briefcase mr-2 prefix-icon">&nbsp;</span>
              <input matInput [(ngModel)]="formData.clinicName" name="clinicName">
            </mat-form-field>
            <p *ngIf="stepErrors.clinicName" class="error-msg">Ingresa el nombre del consultorio</p>

            <mat-form-field class="w-100 mt-2" appearance="fill">
              <mat-label>Persona de contacto *</mat-label>
              <span matPrefix class="fa fa-user mr-2 prefix-icon">&nbsp;</span>
              <input matInput [(ngModel)]="formData.contactName" name="contactName">
            </mat-form-field>
            <p *ngIf="stepErrors.contactName" class="error-msg">Ingresa el nombre de la persona de contacto</p>
          </div>
        </ng-container>

        <!-- Residente -->
        <ng-container *ngIf="!isSpecialist">
          <h3 class="step-title">Tu formación</h3>
          <p class="step-sub">Datos de tu institución educativa</p>
          <div class="fields-wrap mt-4">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>Nombre de la institución *</mat-label>
              <span matPrefix class="fa fa-university mr-2 prefix-icon">&nbsp;</span>
              <input matInput [(ngModel)]="formData.institutionName" name="institutionName">
            </mat-form-field>
            <p *ngIf="stepErrors.institutionName" class="error-msg">Ingresa el nombre de tu institución</p>

            <mat-form-field class="w-100 mt-2" appearance="fill">
              <mat-label>Nombre del coordinador *</mat-label>
              <span matPrefix class="fa fa-user mr-2 prefix-icon">&nbsp;</span>
              <input matInput [(ngModel)]="formData.coordinatorName" name="coordinatorName">
            </mat-form-field>
            <p *ngIf="stepErrors.coordinatorName" class="error-msg">Ingresa el nombre del coordinador</p>

            <mat-form-field class="w-100 mt-2" appearance="fill">
              <mat-label>Fecha de graduación *</mat-label>
              <input matInput [(ngModel)]="formData.graduationDate"
                     [matDatepicker]="picker" [min]="nowDate"
                     name="graduationDate" readonly
                     (dateChange)="setGraduationDate($event)">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker startView="year"></mat-datepicker>
            </mat-form-field>
            <p *ngIf="stepErrors.graduationDate" class="error-msg">Selecciona tu fecha de graduación</p>

            <mat-form-field class="w-100 mt-2" appearance="fill">
              <mat-label>Nombre del consultorio</mat-label>
              <span matPrefix class="fa fa-briefcase mr-2 prefix-icon">&nbsp;</span>
              <input matInput [(ngModel)]="formData.clinicName" name="clinicName">
            </mat-form-field>

            <mat-form-field class="w-100 mt-2" appearance="fill">
              <mat-label>Persona de contacto</mat-label>
              <span matPrefix class="fa fa-user mr-2 prefix-icon">&nbsp;</span>
              <input matInput [(ngModel)]="formData.contactName" name="contactName">
            </mat-form-field>
          </div>
        </ng-container>

      </ng-container>

      <!-- PASO 5: Dirección -->
      <ng-container *ngIf="currentStep === 5">
        <h3 class="step-title">Tu dirección</h3>
        <p class="step-sub">Dirección de tu consultorio o domicilio</p>
        <div class="fields-wrap mt-4">
          <div class="addr-row">
            <mat-form-field class="addr-street" appearance="fill">
              <mat-label>Calle *</mat-label>
              <span matPrefix class="fa fa-map-marker mr-2 prefix-icon">&nbsp;</span>
              <input matInput [(ngModel)]="formData.street" name="street" autocomplete="address-line1">
            </mat-form-field>
            <mat-form-field class="addr-number" appearance="fill">
              <mat-label>Número *</mat-label>
              <input matInput [(ngModel)]="formData.number" name="number">
            </mat-form-field>
          </div>
          <p *ngIf="stepErrors.street" class="error-msg">Ingresa la calle</p>
          <p *ngIf="stepErrors.number" class="error-msg">Ingresa el número</p>

          <div class="addr-row mt-2">
            <mat-form-field class="addr-city" appearance="fill">
              <mat-label>Ciudad *</mat-label>
              <span matPrefix class="fa fa-map-marker mr-2 prefix-icon">&nbsp;</span>
              <input matInput [(ngModel)]="formData.city" name="city" autocomplete="address-level2">
            </mat-form-field>
            <mat-form-field class="addr-zip" appearance="fill">
              <mat-label>C.P. *</mat-label>
              <input matInput phoneNumberOnly maxlength="5"
                     [(ngModel)]="formData.zipCode" name="zipCode" inputmode="numeric">
            </mat-form-field>
          </div>
          <p *ngIf="stepErrors.city" class="error-msg">Ingresa la ciudad</p>
          <p *ngIf="stepErrors.zipCode" class="error-msg">Ingresa el código postal (5 dígitos)</p>

          <mat-form-field class="w-100 mt-2" appearance="fill">
            <mat-label>Estado *</mat-label>
            <span matPrefix class="fa fa-map-marker mr-2 prefix-icon">&nbsp;</span>
            <mat-select [(ngModel)]="formData.state" name="state">
              <mat-option *ngFor="let s of States" [value]="s.name">{{s.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <p *ngIf="stepErrors.state" class="error-msg">Selecciona un estado</p>

          <mat-form-field class="w-100 mt-2 field-readonly" appearance="fill">
            <mat-label>País</mat-label>
            <span matPrefix class="fa fa-globe mr-2 prefix-icon">&nbsp;</span>
            <input matInput value="México" name="country" readonly tabindex="-1">
          </mat-form-field>
        </div>
      </ng-container>

      <!-- PASO 6: Extras opcionales -->
      <ng-container *ngIf="currentStep === 6">
        <h3 class="step-title">Para terminar</h3>
        <p class="step-sub">Estos datos son opcionales, puedes completarlos después</p>
        <div class="fields-wrap mt-4">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label>Sitio web</mat-label>
            <span matPrefix class="fa fa-globe mr-2 prefix-icon">&nbsp;</span>
            <input matInput [(ngModel)]="formData.website" name="website"
                   inputmode="url" placeholder="https://tuclinica.mx">
          </mat-form-field>
          <mat-form-field class="w-100 mt-2" appearance="fill">
            <mat-label>Redes sociales</mat-label>
            <span matPrefix class="fa fa-share-alt mr-2 prefix-icon">&nbsp;</span>
            <input matInput [(ngModel)]="formData.socialMedia" name="socialMedia" placeholder="@tuclinica">
          </mat-form-field>
          <mat-form-field class="w-100 mt-2" appearance="fill">
            <mat-label>Código de referido</mat-label>
            <span matPrefix class="fa fa-link mr-2 prefix-icon">&nbsp;</span>
            <input matInput onlyNumbers [(ngModel)]="formData.referralId" name="referralId">
          </mat-form-field>
        </div>
      </ng-container>

    </div>

    <!-- Navegación -->
    <div class="nav-section px-4 pb-5 mt-3">
      <div *ngIf="submitError" class="submit-error mb-3">
        <i class="fa fa-exclamation-circle mr-1"></i> {{submitError}}
      </div>
      <ng-container *ngIf="!loading">
        <button class="button primary-button w-100" (click)="next()">
          {{currentStep === totalSteps ? 'Registrarme' : 'Continuar'}}
        </button>
        <div class="text-center mt-3" *ngIf="currentStep > 1">
          <a class="back-link" (click)="back()">&#8592; Atrás</a>
        </div>
      </ng-container>
      <div *ngIf="loading" class="text-center py-2">
        <app-loading></app-loading>
      </div>
      <p class="legal-text text-center mt-4" *ngIf="currentStep === totalSteps">
        Al dar clic en "Registrarme" acepto el
        <a href="https://www.aliwell.mx/aviso-de-privacidad" target="_blank" rel="noopener">aviso de privacidad</a>
      </p>
    </div>

  </div>
</div>
